import { render, staticRenderFns } from "./NotReadyView.vue?vue&type=template&id=86f09366&scoped=true"
import script from "./NotReadyView.vue?vue&type=script&lang=js"
export * from "./NotReadyView.vue?vue&type=script&lang=js"
import style0 from "./NotReadyView.vue?vue&type=style&index=0&id=86f09366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f09366",
  null
  
)

export default component.exports